<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Statement Line Type
        <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-flex xs12>
          <form data-vv-scope="queryStmtLnTypeFilterForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg6 xs6>
                            <v-text-field
                              data-vv-scope="queryStmtLnTypeFilterForm"
                              v-model="filtersStmtLnType.stmtLnType"
                              :label="filtersStmtLnTypeLabel.stmtLnType"
                              :error-messages="errors.collect('stmtLnType')"
                              data-vv-name="stmtLnType"
                              :data-vv-as="filtersStmtLnTypeLabel.stmtLnType"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearStmtLnTypeFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.prevent="doStmtLnTypeFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <v-data-table
            :headers="stmtLnTypeHeaders"
            :items="stmtLnTypeItems"
            v-bind:options.sync="paginationStmtLnType"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :server-items-length="totalItemsStmtLnType"
            :loading="loading"
            class="elevation-1"
            :no-data-text="noDataText"
          >
            <template v-slot:item="row"
              ><tr>
                <td>{{ row.item.riType }}</td>
                <td>{{ row.item.stmtLnType }}</td>
                <td>{{ row.item.stmtLnDesc1 }}</td>
                <td>{{ row.item.stmtLnSeq }}</td>
                <td style="text-align: center">
                  <v-btn text icon color="primary" type="submit" @click.prevent="assignStmtLnType(row.item)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </td>
              </tr></template
            >
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      filtersStmtLnTypeLabel: {
        riType: 'RI Type',
        stmtLnType: 'Statement Line'
      },
      filtersStmtLnType: {
        riType: undefined,
        stmtLnType: undefined
      },
      stmtLnTypeItems: [],
      totalItemsStmtLnType: 0,
      stmtLnTypeHeaders: [
        { text: 'RI Type', align: 'left', value: 'riType' },
        { text: 'Stmt Line', value: 'stmtLnType' },
        { text: 'Stmt Line Desc', value: 'stmtLnDesc1' },
        { text: 'Stmt Line Seq', value: 'stmtLnSeq' },
        // { text: 'Cedant Broker', value: 'cedBrk' },
        // { text: 'Cedant Company', value: 'cedCo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationStmtLnType: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearStmtLnTypeFilters()
      }
    },
    'paginationStmtLnType': function (value) {
      this.fetchStmtLnTypeData()
    }
  },
  mounted() {
    // this.doClearStmtLnTypeFilters()
  },
  methods: {
    closeDialog() {
      this.resetFilterForm()
      this.$emit('close')
    },
    doClearStmtLnTypeFilters() {
      this.resetFilterForm()
      this.fetchStmtLnTypeData()
    },
    doStmtLnTypeFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryStmtLnTypeFilterForm').then((result) => {
        if (result) {
          this.paginationStmtLnType.page = 1
          this.fetchStmtLnTypeData()
        }
      })
    },
    async fetchStmtLnTypeData() {
      const apiUrl = this.$store.state.treatyAcct.treatyMaster.menu.getStmtLnTypeListByRITypeTtyMaster
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationStmtLnType
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            riType: this.ttyHeaderForm.riType,
            ttyRef: this.ttyHeaderForm.ttyRef,
            tranDate: formatDisplayDate(this.ttyHeaderForm.tranDate),
            uwYr: this.ttyStmtLnForm,
            stmtType: this.ttyHeaderForm.stmtType
          }
          let messageFilters = clone(this.filtersStmtLnType)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), messageFilters, this.paginationStmtLnType.sortBy, this.paginationStmtLnType.sortDesc)
          )
          if (result.data) {
            this.totalItemsStmtLnType = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.$set(this, 'stmtLnTypeItems', data)
            } else {
              this.$set(this, 'stmtLnTypeItems', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignStmtLnType(data) {
      // Use $emit to call parent Accounts page method assignStmtLnType and pass the value
      this.$emit('assign-stmtLineType', data)
      // this.$emit('assign-acct-no', data.inter)
      this.$emit('close')
    },
    resetFilterForm() {
      this.filtersStmtLnType.riType = ''
      this.filtersStmtLnType.stmtLnType = ''
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    ttyHeaderForm: {
      type: Object,
      default: null
    },
    ttyStmtLnForm: {
      type: Number,
      default: 0
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
